import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { APIKey } from 'src/app/models/api-key';
import { APIKeysService } from '../api-keys.service';

@Component({
  selector: 'app-api-keys-details',
  templateUrl: './api-key-details.component.html',
  styleUrls: ['./api-key-details.component.scss'],
})
export class ApiKeyDetailsComponent implements OnDestroy {
  modifiedAPIKeys: { string?: APIKey } = {};
  pending = false;
  subscription: Subscription = new Subscription();

  @Output() deleteEvent = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { apiKey: APIKey },
    private dialogRef: MatDialogRef<ApiKeyDetailsComponent>,
    private sanitizer: DomSanitizer,
    private entityService: APIKeysService
  ) {}

  bypassSanitizer(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  handleNameChange(event: Event, item: APIKey) {
    const input: HTMLInputElement = <HTMLInputElement>event.target;

    this.updateModifiedAPIKeys(item, { name: input.value });
  }

  updateModifiedAPIKeys(item: APIKey, attributes: Partial<APIKey>) {
    // attributes that can be modified
    const attrs = ['name'];

    if (!this.modifiedAPIKeys[item.id]) {
      this.modifiedAPIKeys[item.id] = {
        ...item,
      };
    }

    Object.keys(attributes).forEach((attr) => {
      this.modifiedAPIKeys[item.id][attr] = attributes[attr];
    });
    const match = attrs.reduce((prev, curr) => {
      return prev && item[curr] === this.modifiedAPIKeys[item.id][curr];
    }, true);
    if (match) {
      delete this.modifiedAPIKeys[item.id];
    }
  }

  getExpiresAtFormatted(apiKey: APIKey): string {
    return apiKey.expires_at ? apiKey.expires_at.toLocaleString() : 'Never';
  }

  handleSaveClick(event: any, item: APIKey) {
    if (!this.modifiedAPIKeys[item.id]) {
      return; // no changes to be saved
    }

    this.pending = true;
    const apiKey = this.modifiedAPIKeys[item.id];
    this.subscription.add(
      this.entityService.updateEntity(apiKey).subscribe(
        (updatedAPIKey) => {
          item.name = updatedAPIKey.name;

          delete this.modifiedAPIKeys[item.id];
        },
        () => {},
        () => {
          this.pending = false;
          this.dialogRef.close();
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
